<div class="toggle-switch" [ngClass]="{'toggle-switch-disabled': disabled}">
  <div class="switch-selector" [ngClass]="{
  'toLeft': switchValue === 'false',
  'toCenter': switchValue === '',
  'toRight': switchValue === 'true'}"></div>
  <div class="switch switch-left" (click)="setValue('false')"></div>
  <div class="switch switch-center" (click)="setValue('')" *ngIf="canBeNull"></div>
  <div class="switch switch-right" (click)="setValue('true')"></div>
</div>
